export const MADE_TO_ORDER_LABEL = 'Made to order';
export const MADE_TO_ORDER_COPY =
  'Made to order products are created from scratch when you complete your order with the seller. As such, these items have varied lead times before they are dispatched for delivery. This is why the delivery times displayed may be longer. For additional info you can see the product description.';
export const MADE_TO_ORDER_INFO = "What's this";
export const NO_LONGER_AVAILABLE_LABEL = 'Sorry, this item is no longer available';
export const OUT_OF_STOCK_LABEL = 'Sorry, this item is currently out of stock';
